import React from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { formatTimeAgo } from "../utils/relativeTime";
import SafeIcon from "../common/SafeIcon";
import { FiClock, FiArrowRight } from "react-icons/fi";
import { articlePathId } from "../utils/articleId";

const NewsCard = ({ article }) => {
  const navigate = useNavigate();
  const timeAgo = formatTimeAgo(article.date);
  const detailPath = `/article/${encodeURIComponent(articlePathId(article.id))}`;

  const goToArticle = () => {
    navigate(detailPath);
  };

  const onCardKeyDown = (e) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      goToArticle();
    }
  };

  return (
    <motion.div
      role="link"
      tabIndex={0}
      aria-label={`Open article: ${article.title}`}
      initial={{ opacity: 0, y: 12 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.35 }}
      className="glass-card flex flex-col h-full group cursor-pointer outline-none focus-visible:ring-2 focus-visible:ring-[#CCFF00]/60 focus-visible:ring-offset-2 focus-visible:ring-offset-[#050505]"
      onClick={goToArticle}
      onKeyDown={onCardKeyDown}
    >
      {article.imageUrl ? (
        <div className="aspect-[16/10] relative overflow-hidden bg-black">
          <img
            src={article.imageUrl}
            className="w-full h-full object-cover opacity-60 group-hover:opacity-100 group-hover:scale-105 transition-all duration-700"
            alt={article.title}
          />
          <div className="absolute top-4 left-4 z-20">
            <span className="bg-[#CCFF00] text-black text-[9px] font-black uppercase tracking-widest px-2 py-1">
              {article.category}
            </span>
          </div>
        </div>
      ) : null}

      <div className="p-8 flex flex-col flex-1">
        <div className="flex items-center gap-1.5 text-[10px] text-slate-500 uppercase tracking-widest mb-6">
          <SafeIcon icon={FiClock} /> {timeAgo}
        </div>

        <h3 className="text-2xl font-black text-white leading-[1.1] mb-6 tracking-tighter uppercase group-hover:text-[#CCFF00] transition-colors">
          {article.title}
        </h3>

        <p className="text-slate-400 text-sm font-medium leading-relaxed mb-8 line-clamp-3">
          {article.excerpt}
        </p>

        <div className="mt-auto pt-6 border-t border-white/5 flex items-center">
          <span className="flex items-center gap-2 text-[#CCFF00] text-[10px] font-black uppercase tracking-widest">
            Read full story{" "}
            <SafeIcon
              icon={FiArrowRight}
              className="group-hover:translate-x-1 transition-transform"
            />
          </span>
        </div>
      </div>
    </motion.div>
  );
};

export default NewsCard;